import { useEffect } from "react";
import ProgressReportSection from "../../components/Reports/New Progress Report/ProgressReportSection";
import CONFIG from "../../utils/config";

export const ProgressReportPageMobile = () => {
    useEffect(() => {
            if (document.getElementById("id_page_404") !== null) {
              document.getElementById("id_page_404").style.display = "none";
            }
        setTimeout(() => {
            if (document.getElementById("cc_div") !== null)
                document.getElementById("cc_div").style.display = "none";
        }, 100)
    }, [])

    useEffect(() => {
        window.scrollTo(0, 0);

        let sendHeight = setInterval(() => {
            let obj = { 'method': 'height', 'value': document.body.scrollHeight }
            console.log('height: ', obj);
            window.parent.postMessage(obj, CONFIG.API_URL_BROKER_ADMIN);
        }, 3000)

        return (() => { clearInterval(sendHeight) })
    }, [])
    return (

        <ProgressReportSection 
            isMobile={true}
        />
    )
}

export default ProgressReportPageMobile;